import { Injectable, OnDestroy } from '@angular/core';

import { MessageService } from 'primeng/api';

import { DataConnectorsApi } from '@api/externalData/data-connectors.api';
import { SavedMentionSearchesApi } from '@api/mentions/saved-mention-searches.api';
import { MentionsApi } from '@api/mentions/mentions.api';
import { ExternalDataApi } from '@api/externalData/external-data.api';

import { ReportsSeriesMapperService } from '@Common/Reports/services/reports-series-mapper.service';
import { LocalizationService } from '@Core/Localization/services/localization.service';
import { CurrentUserStateService } from '@Core/Users/services/current-user-state.service';
import { ReportsExternalDataMapperService } from '@Common/Reports/services/report-external-data-mapper.service';
import { IndexeddbCoreCacheService } from '@Core/Cache/services/indexeddb-core-cache.service';
import { MediaSubscriptionService } from '@Monitor/Core/services/media-subscription.service';
import { ThemeService } from '@Social/Intelligence/services/theme.service';
import { CurrencyConversionService } from '@Core/Users/services/currency-conversion.service';
import { DataConnectionService } from '@Core/Users/services/data-connection.service';
import { ReportsSeriesDataMapperService } from '@Common/Reports/services/reports-series-data-mapper.service';
import { AgentService } from '@Social/Intelligence/services/agent.service';

import { BriefingSeriesService } from '../../Briefings/services/briefing-series.service';
import { AlertsService } from './alerts.service';

@Injectable()
export class AlertSeriesService extends BriefingSeriesService implements OnDestroy {

    constructor(
        alertsService: AlertsService,
        savedSearchesApi: SavedMentionSearchesApi,
        mentionsApi: MentionsApi,
        reportsSeriesMapperService: ReportsSeriesMapperService,
        localizationService: LocalizationService,
        externalDataMapperService: ReportsExternalDataMapperService,
        messageService: MessageService,
        currentUserStateService: CurrentUserStateService,
        externalDataApi: ExternalDataApi,
        indexedDbCoreCacheService: IndexeddbCoreCacheService,
        mediaSubscriptionService: MediaSubscriptionService,
        themeService: ThemeService,
        currencyConversionService: CurrencyConversionService,
        dataConnectionService: DataConnectionService,
        reportsSeriesDataMapperService: ReportsSeriesDataMapperService,
        dataConnectorsApiService: DataConnectorsApi,
        agentService: AgentService
    ) {
        super(
            alertsService as any,
            savedSearchesApi,
            mentionsApi,
            reportsSeriesMapperService,
            localizationService,
            externalDataMapperService,
            messageService,
            currentUserStateService,
            externalDataApi,
            indexedDbCoreCacheService,
            mediaSubscriptionService,
            themeService,
            currencyConversionService,
            dataConnectionService,
            reportsSeriesDataMapperService,
            dataConnectorsApiService,
            agentService
        );
    }
}
